import React from 'react';

import { VirtualMachineIcon } from 'components/Icons';
import { CDashboard } from 'components/Visualization';
import { infrastructureDashboardConfig } from 'containers/Dashboard/CloudPostureOverview/config';
import { DashboardOverviewWrapperCard } from 'containers/Dashboard/utils/DashboardOverviewWrapperCard';

export const InfrastructurePosture: React.FC = () => {
  return (
    <DashboardOverviewWrapperCard
      label="Infrastructure Security"
      content={<CDashboard dashboardWidgets={infrastructureDashboardConfig} />}
      icon={<VirtualMachineIcon />}
      redirectLink={{
        link: '/findings?tab=Overview&categoryClass=Cloud Posture',
        localStorageKey: 'findings_overview_category_class',
        localStorageValue: 'Cloud Posture',
      }}
    />
  );
};
